import { Table } from 'antd';
import React from 'react'

const ModalViewBin = ({ displayBinData }) => {
    console.log(displayBinData);
    if (!Array.isArray(displayBinData)) {
        console.error('displayBinData is not an array:', displayBinData);
        return <div>Error: Invalid data</div>;
    }

    const aggregatedData = displayBinData.reduce(
        (acc, item) => {
            try {
                if (item.size_qty) {
                    const sizeQty = JSON.parse(item.size_qty); // Ensure size_qty is a valid JSON string
                    if (typeof sizeQty === 'object' && sizeQty !== null) {
                        Object.entries(sizeQty).forEach(([size, qty]) => {
                            if (qty) {
                                acc.sizeData[size] = (acc.sizeData[size] || 0) + Number(qty);
                                acc.totalQty += Number(qty);
                            }
                        });
                    }
                }
            } catch (error) {
                console.error(`Error parsing size_qty for item:`, item, error);
            }
            return acc;
        },
        { sizeData: {}, totalQty: 0 }
    );


    const tableDataSource = Object.entries(aggregatedData.sizeData).map(
        ([size, quantity], index) => ({
            key: index,
            size,
            quantity,
        })
    );


    const columns = [
        {
            title: 'Size',
            dataIndex: 'size',
            key: 'size',
        },
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            key: 'quantity',
        },
    ];

    return (
        <>
            <div style={{ display: "flex", justifyContent: "space-between", padding: "16px" }}>
                <div>
                    <strong>Item No.:</strong> {displayBinData[0]?.item_no}
                </div>
                <div>
                    <strong>Style No.:</strong> {displayBinData[0]?.style_no}
                </div>
            </div>
            <Table
                dataSource={tableDataSource}
                columns={columns} pagination={false}
                footer={() => (
                    <div style={{ textAlign: "right", paddingRight: "16px" }}>
                        <strong>Total Quantity: {aggregatedData.totalQty}</strong>
                    </div>
                )}
            />

        </>
    )
}

export default ModalViewBin